import { Molecule } from 'AppReact';
import styled from 'styled-components';
import { Icon, } from './atoms';
import { Text } from 'atoms';
import { CloseSvg } from 'components/icons';

const template = styled.div`
  display: inline-flex;
  align-items: center;
  padding: 4px 6px;
  font-size: 12px;
  line-height: 14px;
  background-color: #FFF4F4;
  color: #FD2020;
  margin-top: 5px;
  border-radius: 4px;
`;

export default Molecule({
  template,
  atoms: [
    {
      component: Icon,
      name: 'Icon',
      displayValue: ({ }) => CloseSvg({ width: "18", height: "18", color: "#FD2020" })
    },
    {
      component: Text,
      name: 'Text',
      displayValue: ({ }) => 'Not assigned to any property',
    },
  ],
})